import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


import {SlickCarouselModule} from 'ngx-slick-carousel';

import { CoursesCarouselComponent } from './courses-carousel.component';
import { PriceModule } from 'app/components/price/price.module';

@NgModule({
  declarations: [
    CoursesCarouselComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PriceModule,
    SlickCarouselModule
  ],
  exports: [
    CoursesCarouselComponent
  ]
})
export class CoursesCarouselModule { }
